import { LaboratorialAnalysis } from 'types/LaboratorialAnalysis'

export function instanceOfLaboratorialAnalysis(
  data: any
): data is LaboratorialAnalysis[] {
  return data?.length > 0 && data[0].name !== undefined
}
